module.exports = __webpack_public_path__ + "static/media/chef-light-gray.a368e9ab.svg";